import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["input", "results", "businessId"]

  connect() {
    this.searchUrl = this.data.get("searchUrl")
    this.searchTimer = null
  }

  search() {
    clearTimeout(this.searchTimer)
    const query = this.inputTarget.value.trim()

    if (query.length < 2) {
      this.resultsTarget.innerHTML = ""
      this.resultsTarget.classList.add("hidden")
      return
    }

    this.searchTimer = setTimeout(() => {
      this.performSearch(query)
    }, 300)
  }

  performSearch(query) {
    const url = `${this.searchUrl}?query=${encodeURIComponent(query)}`

    fetch(url, {
      headers: { "Accept": "application/json" }
    })
      .then(response => response.json())
      .then(data => {
        this.renderResults(data)
      })
      .catch(() => {
        this.resultsTarget.innerHTML = ""
        this.resultsTarget.classList.add("hidden")
      })
  }

  renderResults(contractors) {
    if (contractors.length === 0) {
      this.resultsTarget.innerHTML = '<p class="px-3 py-2 text-xs text-gray-500">No matching contractors found</p>'
      this.resultsTarget.classList.remove("hidden")
      return
    }

    const html = contractors.map(c => {
      return `<button type="button"
        class="w-full text-left px-3 py-2 text-sm text-gray-700 hover:bg-purple-50 hover:text-purple-700 cursor-pointer"
        data-action="click->contractor-override-search#select"
        data-business-id="${c.id}">
        ${this.escapeHtml(c.name)}
      </button>`
    }).join("")

    this.resultsTarget.innerHTML = html
    this.resultsTarget.classList.remove("hidden")
  }

  select(event) {
    const businessId = event.currentTarget.dataset.businessId
    this.businessIdTarget.value = businessId
    this.inputTarget.value = event.currentTarget.textContent.trim()
    this.resultsTarget.innerHTML = ""
    this.resultsTarget.classList.add("hidden")

    this.businessIdTarget.closest("form").requestSubmit()
  }

  escapeHtml(text) {
    const div = document.createElement("div")
    div.textContent = text
    return div.innerHTML
  }
}
